exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".select-small.el-select .el-input .el-input__inner[data-v-c6bedcb8] {\n  height: 31px;\n}\n.table td[data-v-c6bedcb8] {\n  padding: 0.3rem;\n}", "", {"version":3,"sources":["/var/www/html/brkt/src/app/components/Archived.vue"],"names":[],"mappings":"AACA;EACE,aAAA;CAAF;AAEA;EACE,gBAAA;CACF","file":"Archived.vue?vue&type=style&index=0&id=c6bedcb8&lang=scss&scoped=true","sourcesContent":["\n.select-small.el-select .el-input .el-input__inner {\n  height: 31px;\n}\n.table td {\n  padding: 0.3rem;\n} \n"],"sourceRoot":""}]);

// exports
